import React, { useRef, useState } from "react"
import { Container, Stage, Graphics, useTick } from "@inlet/react-pixi"
import ContextBridge from "./context-bridge"
import Background from "components/background"
import { GameContext } from "utils/game-context"

const _Stage = ({ onResize, stageRef, h, w, children }) => {
  useTick(
    delta =>
      stageRef.current.parentNode &&
      (h !== stageRef.current.parentNode.clientHeight ||
        w !== stageRef.current.parentNode.clientWidth) &&
      onResize(
        stageRef.current.parentNode.clientWidth,
        stageRef.current.parentNode.clientHeight
      )
  )
  return <>{children}</>
}

const Scene = ({ options, children }) => {
  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(300)

  const ref = useRef()
  const mask = useRef()
  const scale = Math.min(width / 300.0, height / 180.0) * 0.8

  return (
    <div ref={ref} style={{ position: "absolute", left: 0, top: 0 }}>
      <ContextBridge
        Context={GameContext}
        render={children => (
          <Stage width={width} height={height} options={options}>
            <Background
              width={width}
              height={height}
              scale={{ x: scale, y: scale }}
            />
            {children}
          </Stage>
        )}
      >
        <_Stage
          h={height}
          w={width}
          onResize={(w, h) => {
            if (w !== width) setWidth(w)
            if (h !== height) setHeight(h)
          }}
          stageRef={ref}
        >
          <Container
            blur={80}
            x={(width - 300 * scale) / 2}
            y={(height - 300 * scale) / 2 - 20}
            width={300}
            height={300}
            scale={{ x: scale, y: scale }}
            mask={mask.current}
          >
            <Graphics
              x={0}
              y={60}
              preventRedraw={true}
              draw={g => {
                g.beginFill(0x000000)
                g.drawRect(0, 0, 300, 180)
                g.endFill()
              }}
              ref={mask}
            />

            {children}
          </Container>
        </_Stage>
      </ContextBridge>
    </div>
  )
}

export default Scene
/*            mask={mask.current}
 */
